var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("CRM event maken")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: { items: _vm.items, label: "Event type", fancy: "" },
                    model: {
                      value: _vm.crm.eventId,
                      callback: function ($$v) {
                        _vm.$set(_vm.crm, "eventId", $$v)
                      },
                      expression: "crm.eventId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { staticClass: "section-title", attrs: { xs: "12" } },
                [_vm._v(" Metadata: ")]
              ),
            ],
            1
          ),
          _vm._l(_vm.keys, function (metadataKey, i) {
            return _c(
              "w-row",
              { key: i },
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12" } },
                  [
                    _c(
                      "w-row",
                      { attrs: { "no-margin": "" } },
                      [
                        _c("w-input", {
                          staticClass: "grow mr",
                          attrs: { label: "Naam", fancy: "" },
                          model: {
                            value: _vm.keys[i],
                            callback: function ($$v) {
                              _vm.$set(_vm.keys, i, $$v)
                            },
                            expression: "keys[i]",
                          },
                        }),
                        _c("w-input", {
                          staticClass: "grow mr",
                          attrs: { label: "Waarde", fancy: "" },
                          model: {
                            value: _vm.values[i],
                            callback: function ($$v) {
                              _vm.$set(_vm.values, i, $$v)
                            },
                            expression: "values[i]",
                          },
                        }),
                        _c(
                          "w-button",
                          {
                            staticClass: "no-shrink",
                            on: {
                              click: function ($event) {
                                return _vm.removeMetaDataField(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "minus" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm.keys.length == 0
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    {
                      staticClass: "gray-text",
                      attrs: { xs: "12", center: "" },
                    },
                    [_vm._v(" Druk op de plus om metadata toe te voegen ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.addMetaDataField()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }